var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExamModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:exam-mode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.625 14.375V16.25H4.375V10.5188L6.61875 12.7563L7.5 11.875L3.75 8.125L0 11.875L0.88125 12.7563L3.125 10.5188V16.25C3.125 16.5815 3.2567 16.8995 3.49112 17.1339C3.72554 17.3683 4.04348 17.5 4.375 17.5H15.625C15.9565 17.5 16.2745 17.3683 16.5089 17.1339C16.7433 16.8995 16.875 16.5815 16.875 16.25V14.375H15.625ZM16.875 4.375V10.1062L19.1187 7.86875L20 8.75L16.25 12.5L12.5 8.75L13.3813 7.86875L15.625 10.1062V4.375H8.125V3.125H15.625C15.9565 3.125 16.2745 3.2567 16.5089 3.49112C16.7433 3.72554 16.875 4.04348 16.875 4.375ZM5 6.25H2.5C2.16848 6.25 1.85054 6.1183 1.61612 5.88388C1.3817 5.64946 1.25 5.33152 1.25 5V2.5C1.25 2.16848 1.3817 1.85054 1.61612 1.61612C1.85054 1.3817 2.16848 1.25 2.5 1.25H5C5.33152 1.25 5.64946 1.3817 5.88388 1.61612C6.1183 1.85054 6.25 2.16848 6.25 2.5V5C6.25 5.33152 6.1183 5.64946 5.88388 5.88388C5.64946 6.1183 5.33152 6.25 5 6.25ZM2.5 2.5V5H5V2.5H2.5Z",
    fill: "white",
    fillOpacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamModule);
export default __webpack_public_path__ + "static/media/exam-module.aa86170e42b590ab908a28df5eaed235.svg";
export { ForwardRef as ReactComponent };